import { BASE_PATH as g, BaseAPI as C, operationServerMap as p } from "../base.js";
import { DUMMY_BASE_URL as V, assertParamExists as d, createRequestFunction as v, setSearchParams as h, toPathString as b } from "../common.js";
import m from "axios";
var A = function(s) {
  return { businessConfigGetConfigVal: async (n, o = {}) => {
    d("businessConfigGetConfigVal", "configKey", n);
    const a = "/business/config/get/{configKey}".replace("{configKey}", encodeURIComponent(String(n))), i = new URL(a, V);
    let e;
    s && (e = s.baseOptions);
    const r = {
      method: "GET",
      ...e,
      ...o
    }, t = {};
    h(i, {});
    let l = e && e.headers ? e.headers : {};
    return r.headers = {
      ...t,
      ...l,
      ...o.headers
    }, {
      url: b(i),
      options: r
    };
  } };
}, c = function(s) {
  const n = A(s);
  return { async businessConfigGetConfigVal(o, a) {
    var i, e;
    const r = await n.businessConfigGetConfigVal(o, a), t = (i = s == null ? void 0 : s.serverIndex) !== null && i !== void 0 ? i : 0, l = (e = p["BusinessConfigApi.businessConfigGetConfigVal"]) === null || e === void 0 || (e = e[t]) === null || e === void 0 ? void 0 : e.url;
    return (f, u) => v(r, m, g, s)(f, l || u);
  } };
}, G = function(s, n, o) {
  const a = c(s);
  return { businessConfigGetConfigVal(i, e) {
    return a.businessConfigGetConfigVal(i.configKey, e).then((r) => r(o, n));
  } };
}, S = class extends C {
  businessConfigGetConfigVal(s, n) {
    return c(this.configuration).businessConfigGetConfigVal(s.configKey, n).then((o) => o(this.axios, this.basePath));
  }
};
export {
  S as BusinessConfigApi,
  A as BusinessConfigApiAxiosParamCreator,
  G as BusinessConfigApiFactory,
  c as BusinessConfigApiFp
};

//# sourceMappingURL=business-config-api.js.map